import orderBy from 'lodash/orderBy'
import uniq from 'lodash/uniq'
import { OUTLET_ROOT_ID, OUTLET_ROOT_NAME } from './outletCategoryConstants'

const collectBrandIds = (items = []) => uniq(items.map((item) => item.brandId).filter(Boolean))

const buildSubcategoryChildren = (categoryItems = []) => {
  const titleMap = new Map()

  categoryItems.forEach((categoryItem) => {
    ;(categoryItem.subcategories || []).forEach((subcategory) => {
      const title = subcategory.title?.trim()

      if (!title) {
        return
      }

      if (!titleMap.has(title)) {
        titleMap.set(title, { name: title, subcategoryIds: [], brandIds: new Set() })
      }

      const node = titleMap.get(title)

      if (subcategory.id) {
        node.subcategoryIds.push(subcategory.id)
      }

      if (categoryItem.brandId) {
        node.brandIds.add(categoryItem.brandId)
      }
    })
  })

  return orderBy(
    [...titleMap.values()].map((node) => ({
      name: node.name,
      level: 'subcategory',
      subcategoryIds: uniq(node.subcategoryIds),
      brandIds: [...node.brandIds],
    })),
    ['name'],
    ['asc']
  )
}

const buildCategoryChildren = (childrenGrouped = {}) =>
  orderBy(
    Object.entries(childrenGrouped).map(([name, categoryItems]) => ({
      name,
      level: 'category',
      categoryIds: categoryItems.map((item) => item.categoryId),
      brandIds: collectBrandIds(categoryItems),
      children: buildSubcategoryChildren(categoryItems),
    })),
    ['name'],
    ['asc']
  )

export const buildOutletCategoryBranch = (outletGlobalCategories = [], outletProducts = []) => {
  const outletGlobals = outletGlobalCategories.map((globalCategory) => {
    const categoryItems = Object.values(globalCategory.children || {}).flat()
    const categoryIdsInGlobal = new Set(categoryItems.map((item) => item.categoryId))
    const productsInGlobal = outletProducts.filter((product) => categoryIdsInGlobal.has(product.categoryId))

    return {
      id: `outlet:${globalCategory.id}`,
      globalCategoryId: globalCategory.id,
      name: globalCategory.name,
      url: globalCategory.url,
      order: globalCategory.order,
      source: 'outlet',
      level: 'global',
      brandIds: collectBrandIds(productsInGlobal),
      children: buildCategoryChildren(globalCategory.children),
    }
  })

  if (outletGlobals.length === 0) {
    return null
  }

  return {
    id: OUTLET_ROOT_ID,
    name: OUTLET_ROOT_NAME,
    source: 'outlet',
    level: 'outlet_root',
    order: 99999,
    brandIds: uniq(outletProducts.map((product) => product.brandId).filter(Boolean)),
    children: outletGlobals,
  }
}

export default buildOutletCategoryBranch
